'use strict';

var DIMENSIONS = {
    SMALL: '480px',
    MEDIUM: '769px',
    LARGE: '1025px',
    XLARGE: '1440px',
};
(function (BUTTON_VARIANT) {
    BUTTON_VARIANT["LINK"] = "link";
    BUTTON_VARIANT["PRIMARY"] = "primary";
    BUTTON_VARIANT["SECONDARY"] = "secondary";
    BUTTON_VARIANT["PRIMARY_HEADER"] = "primaryHeader";
    BUTTON_VARIANT["CLOSE_BUTTON"] = "closeButton";
    BUTTON_VARIANT["PRIMARY_LINK"] = "primaryLink";
    BUTTON_VARIANT["DANGER"] = "danger";
})(exports.BUTTON_VARIANT || (exports.BUTTON_VARIANT = {}));
(function (THEME_VARIANT) {
    THEME_VARIANT["ADMIN"] = "admin";
    THEME_VARIANT["CONSUMER"] = "consumer";
})(exports.THEME_VARIANT || (exports.THEME_VARIANT = {}));
(function (ZINDEX) {
    ZINDEX[ZINDEX["MODAL_BACKGROUND"] = 13] = "MODAL_BACKGROUND";
    ZINDEX[ZINDEX["MODAL_CONTAINER"] = 14] = "MODAL_CONTAINER";
})(exports.ZINDEX || (exports.ZINDEX = {}));
var DEFAULT_TIME_ZONE = 'America/New_York';
(function (TIMEZONE_OPTIONS) {
    TIMEZONE_OPTIONS["AMERICA_NEW_YORK"] = "America/New_York";
    TIMEZONE_OPTIONS["AMERICA_LOS_ANGELES"] = "America/Los_Angeles";
    TIMEZONE_OPTIONS["EUROPE_BERLIN"] = "Europe/Berlin";
    TIMEZONE_OPTIONS["EUROPE_MOSCOW"] = "Europe/Moscow";
    TIMEZONE_OPTIONS["CANADA_CENTRAL"] = "Canada/Central";
    TIMEZONE_OPTIONS["EUROPE_PARIS"] = "Europe/Paris";
})(exports.TIMEZONE_OPTIONS || (exports.TIMEZONE_OPTIONS = {}));
var DEFAULT_TIMEZONE_OPTIONS = [
    exports.TIMEZONE_OPTIONS.AMERICA_NEW_YORK,
    exports.TIMEZONE_OPTIONS.AMERICA_LOS_ANGELES,
    exports.TIMEZONE_OPTIONS.EUROPE_BERLIN,
    exports.TIMEZONE_OPTIONS.EUROPE_MOSCOW,
    exports.TIMEZONE_OPTIONS.CANADA_CENTRAL,
    exports.TIMEZONE_OPTIONS.EUROPE_PARIS,
];
(function (LOCALE_OPTIONS) {
    LOCALE_OPTIONS["EN_US"] = "en-US";
    LOCALE_OPTIONS["DE_DE"] = "de-DE";
    LOCALE_OPTIONS["RU_RU"] = "ru-RU";
    LOCALE_OPTIONS["FR_CA"] = "fr-CA";
    LOCALE_OPTIONS["FR_FR"] = "fr-Fr";
})(exports.LOCALE_OPTIONS || (exports.LOCALE_OPTIONS = {}));
var DEFAULT_LOCALE_OPTIONS = [
    exports.LOCALE_OPTIONS.EN_US,
    exports.LOCALE_OPTIONS.DE_DE,
    exports.LOCALE_OPTIONS.RU_RU,
    exports.LOCALE_OPTIONS.FR_CA,
    exports.LOCALE_OPTIONS.FR_FR,
];
var weekLength = 7;
(function (WHITELABEL_DOMAINS) {
    WHITELABEL_DOMAINS["HQO"] = "hqo.co";
    WHITELABEL_DOMAINS["VORNADO"] = "vno.com";
    WHITELABEL_DOMAINS["GROSVENOR"] = "70gsapp.com";
    WHITELABEL_DOMAINS["LINCOLN_CENTRE"] = "lchqo.com";
})(exports.WHITELABEL_DOMAINS || (exports.WHITELABEL_DOMAINS = {}));
var WHITELABEL_BY_HOSTNAME = {
    liveworkdo: exports.WHITELABEL_DOMAINS.VORNADO,
    '70gsapp': exports.WHITELABEL_DOMAINS.GROSVENOR,
    lchqo: exports.WHITELABEL_DOMAINS.LINCOLN_CENTRE,
};
var OFFLINE_BRAND_HEADER_COLOR = {
    VORNADO: '#142C4B',
    HQO: '#257BAD',
};
var IMG_URL = 'https://hqo.imgix.net/';
var DEFAULT_AVATAR_URL = 'uploads/default_avatar.png';
(function (CONTENT_HEADING_IDS) {
    CONTENT_HEADING_IDS["HOME"] = "home-anchor-for-scroll";
    CONTENT_HEADING_IDS["SPOTLIGHT"] = "spotlight-anchor-for-scroll";
    CONTENT_HEADING_IDS["DISCOVER"] = "discover-anchor-for-scroll";
    CONTENT_HEADING_IDS["UTILITIES"] = "utilities-anchor-for-scroll";
})(exports.CONTENT_HEADING_IDS || (exports.CONTENT_HEADING_IDS = {}));
var DEFAULT_PAGE_COORDINATES = {
    X: 0,
    Y: 0,
};
var HEADER_HEIGHT = 64;
(function (APP_BRANDS) {
    APP_BRANDS["HQO"] = "HqO";
    APP_BRANDS["VORNADO"] = "Live. Work. Do";
})(exports.APP_BRANDS || (exports.APP_BRANDS = {}));
var OFFLINE_BRAND_HEADER_LOGOS = {
    HQO: 'assets/themes/theme-1-white.png',
};
var FIRST_ITEM_INDEX = 0;
var ENTER_KEY = 13;
var SPACE_KEY = 32;
var IMAGE_ALT_TEXT = 'image of';
var DEFAULT_ACCEPTED_FILE_TYPES = '.jpg, .png, .jpeg';
var FILE_NAME_TRUNCATED_LENGTH = 35;
var MAX_FILE_NAME_LENGTH = 45;
var TILE_TYPES = {
    UTILITY: 'utility',
    AMENITY: 'amenity',
};
var PROVIDERS_STATUSES = {
    CLOSING_SOON: 'Closing soon',
    OPEN: 'Open',
    CLOSED: 'Closed',
    PENDING: 'Pending',
    POSITIVE: 'Positive',
    NEGATIVE: 'Negative',
    NOTICE: 'Notice',
    INFORMATIVE: 'Informative',
};
var STATUS_PILL_VARIANT = {
    ROUNDED: 'rounded',
    SQUARED: 'squared',
};

exports.DEFAULT_ACCEPTED_FILE_TYPES = DEFAULT_ACCEPTED_FILE_TYPES;
exports.DEFAULT_AVATAR_URL = DEFAULT_AVATAR_URL;
exports.DEFAULT_LOCALE_OPTIONS = DEFAULT_LOCALE_OPTIONS;
exports.DEFAULT_PAGE_COORDINATES = DEFAULT_PAGE_COORDINATES;
exports.DEFAULT_TIMEZONE_OPTIONS = DEFAULT_TIMEZONE_OPTIONS;
exports.DEFAULT_TIME_ZONE = DEFAULT_TIME_ZONE;
exports.DIMENSIONS = DIMENSIONS;
exports.ENTER_KEY = ENTER_KEY;
exports.FILE_NAME_TRUNCATED_LENGTH = FILE_NAME_TRUNCATED_LENGTH;
exports.FIRST_ITEM_INDEX = FIRST_ITEM_INDEX;
exports.HEADER_HEIGHT = HEADER_HEIGHT;
exports.IMAGE_ALT_TEXT = IMAGE_ALT_TEXT;
exports.IMG_URL = IMG_URL;
exports.MAX_FILE_NAME_LENGTH = MAX_FILE_NAME_LENGTH;
exports.OFFLINE_BRAND_HEADER_COLOR = OFFLINE_BRAND_HEADER_COLOR;
exports.OFFLINE_BRAND_HEADER_LOGOS = OFFLINE_BRAND_HEADER_LOGOS;
exports.PROVIDERS_STATUSES = PROVIDERS_STATUSES;
exports.SPACE_KEY = SPACE_KEY;
exports.STATUS_PILL_VARIANT = STATUS_PILL_VARIANT;
exports.TILE_TYPES = TILE_TYPES;
exports.WHITELABEL_BY_HOSTNAME = WHITELABEL_BY_HOSTNAME;
exports.weekLength = weekLength;
